import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Poster Visualization',
  attributeName: 'tags-manager-poster',
  fields: [
    {
      attributeName: 'posterTagMode',
      helpText: 'Select how the tag is going to be shown',
      type: FormInputTypes.SELECT,
      label: 'Tag Mode',
      placeholder: 'Tag Mode...',
      emptyValue: true,
      default: '(Empty)', //default value to empty option      
      options: [
        { name: 'Custom Design', value: 'text' },
        { name: 'Upload Image', value: 'image' },
      ],
    },
    {
      attributeName: 'posterLabel',
      helpText: 'Label of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Label',
      placeholder: 'Label...',
      visibleWhen: { "field": "posterTagMode", "value": "text" }

    },
    {
      attributeName: 'posterWidth',
      helpText: 'Select Fixed width for long tags specially for poster tags, and inline for short tags or tags you need to be as big as the tag is',
      type: FormInputTypes.SELECT,
      label: 'Width',
      placeholder: 'Width...',
      options: [
        { name: 'Fixed width', value: 'fixed' },
        { name: 'Inline', value: 'inline' },
      ],
      visibleWhen: { "field": "posterTagMode", "value": "text" }

    },
    {
      attributeName: 'posterFont',
      helpText: 'Font of the tag',
      type: FormInputTypes.SELECT,
      label: 'Font',
      placeholder: 'Font...',
      options: [
        { name: 'BT Brik', value: 'bt-brik' },
        { name: 'Montserrat', value: 'montserrat' },

      ],
      visibleWhen: [
        { "field": "posterTagMode", "value": "text" },
        { "field": "category", "notValue": 7, "allowUndefined": true }
      ]
    },
    {
      attributeName: 'posterIconId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Icon',
      helpText: 'Icon of the tag.',
      placeholder: 'Icon...',
      fileType: ['image/*'],
      canUpdate: false,
      hasSelect: false,
      visibleWhen: [
        { "field": "posterTagMode", "value": "text" },
        { "field": "category", "notValue": 7, "allowUndefined": true }

      ]
    },
    {
      attributeName: 'posterIconId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Image',
      helpText: 'Image of the tag.',
      placeholder: 'Image...',
      fileType: ['image/*'],
      canUpdate: false,
      hasSelect: false,
      visibleWhen: [
        { "field": "posterTagMode", "value": "image" },
        { "field": "category", "notValue": 7, "allowUndefined": true }

      ]
    },
    {
      attributeName: 'posterTextColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Text Color',
      helpText: 'Text color of the tag',
      alphaAllow: true,
      visibleWhen: [
        { "field": "posterTagMode", "value": "text" },
        { "field": "category", "notValue": 7, "allowUndefined": true }

      ]
    },
    {
      attributeName: 'posterBkColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Background Color',
      alphaAllow: true,
      helpText: 'Background color of the tag',
      visibleWhen: [
        { "field": "posterTagMode", "value": "text" },
        { "field": "category", "notValue": 7, "allowUndefined": true }

      ]
    },
    {
      attributeName: 'posterVisible',
      helpText: 'This checkbox is for the display of the tag on poster. If it is set to false, it will not appear on that representation.',
      type: FormInputTypes.CHECKBOX,
      label: 'Visible',
      // default: true,
    },
  ],
};
